import React, { useEffect } from "react";
import { useFieldArray } from "react-hook-form";

import { AddButton } from "../features/task-manager/task-list-components/Buttons";
import SubQuestion from "./sub-question";

const AddSubQuestion = ({ methods, sectionIndex, languages }) => {
  const { fields, append, remove } = useFieldArray({
    control: methods.control,
    name: `payload.sections.${sectionIndex}.fields`,
  });
  return (
    <div>
      {fields.map((field, index) => {
        return (
          <SubQuestion
            field={field}
            index={index}
            languages={languages}
            methods={methods}
            remove={remove}
            sectionIndex={sectionIndex}
            key={Date.now() + Math.random()}
          />
        );
      })}
      <AddButton
        text="Add New Question"
        onClick={() =>
          append({
            key: "",
            name: Object.fromEntries(languages.map((lng) => [lng, ""])),
            field_type: "",
            options: Object.fromEntries(languages.map((lng) => [lng, ""])),
            other_text: Object.fromEntries(languages.map((lng) => [lng, ""])),
            validation: false,
            more: {},
          })
        }
      />
      <hr className="my-6 p-2" />
    </div>
  );
};

export default AddSubQuestion;
